import { Document, Page, pdfjs } from "react-pdf";
import { useState } from "react";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";
//@ts-ignore
import AgroyaarLoading from "../../../gif/Ripple-1s-200px.gif";


pdfjs.GlobalWorkerOptions.workerSrc = "/pdfjs/pdf.worker.js";

interface PdfViewerProps {
  fileUrl: string;
}

function PdfViewer({ fileUrl }: PdfViewerProps) {
  const [numPages, setNumPages] = useState<number | null>(null);

  const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
    setNumPages(numPages);
  };

  return (
    <Document
      file={fileUrl}
      onLoadSuccess={onDocumentLoadSuccess}
      loading={<img src={AgroyaarLoading} alt="fallback" />}
    >
      {Array.from(new Array(numPages), (_, index) => (
        <Page
          key={`page_${index + 1}`}
          pageNumber={index + 1}
          width={800}
          loading={<img src={AgroyaarLoading} alt="fallback" />}
          className="pdf-page"
        />
      ))}
    </Document>
  );
}

export default PdfViewer;
